import React from 'react';
import { Lightbulb, CheckCircle2, ArrowRight } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-8 md:py-12 bg-navy-800 relative overflow-hidden" data-id="element-210">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl" data-id="element-211"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" data-id="element-212"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-213">
        <div className="text-center mb-6 md:mb-10" data-id="element-214">
          <h2 className="text-2xl md:text-4xl font-heading font-black text-white mb-2 md:mb-4 flex items-center justify-center gap-2 md:gap-3" data-id="element-215">
            <Lightbulb className="w-8 h-8 md:w-10 md:h-10 text-gold-400" data-id="element-216" />
            El cambio que lo transforma todo
          </h2>
          <p className="text-lg md:text-xl text-slate-300" data-id="element-217">
            Cuando tenés un sistema… Todo cambia. De verdad.
          </p>
        </div>

        <div className="bg-navy-900 rounded-2xl p-4 md:p-8 border border-navy-700 shadow-xl mb-6 md:mb-10" data-id="element-218">
          <h3 className="text-lg md:text-xl font-bold text-white mb-4 md:mb-6 text-center" data-id="element-219">
            Pasás de:
          </h3>

          <div className="grid md:grid-cols-[1fr_auto_1fr] gap-3 md:gap-8" data-id="element-220">
            <div className="space-y-2 md:space-y-3" data-id="element-221">
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-222">
                <span className="text-red-500 font-bold" data-id="element-223">❌</span>
                <span className="line-through" data-id="element-224">Hacer todo vos</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-225">
                <span className="text-red-500 font-bold" data-id="element-226">❌</span>
                <span className="line-through" data-id="element-227">Repetir constantemente</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-228">
                <span className="text-red-500 font-bold" data-id="element-229">❌</span>
                <span className="line-through" data-id="element-230">Reaccionar</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-slate-400 bg-navy-950/50 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-231">
                <span className="text-red-500 font-bold" data-id="element-232">❌</span>
                <span className="line-through" data-id="element-233">Vivir en caos</span>
              </div>
            </div>

            <div className="hidden md:flex flex-col justify-center items-center text-gold-500/30" data-id="element-234">
              <ArrowRight className="w-12 h-12" data-id="element-235" />
            </div>

            <div className="space-y-2 md:space-y-3" data-id="element-236">
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-237">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-238" />
                <span className="font-bold" data-id="element-239">Dirigir con claridad</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-240">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-241" />
                <span className="font-bold" data-id="element-242">Tener procesos definidos</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-243">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-244" />
                <span className="font-bold" data-id="element-245">Anticiparte</span>
              </div>
              <div className="flex items-center gap-2 md:gap-3 text-white bg-gold-500/10 border border-gold-500/20 p-2 md:p-3 rounded-lg text-sm md:text-base" data-id="element-246">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-gold-400 flex-shrink-0" data-id="element-247" />
                <span className="font-bold" data-id="element-248">Operar con control</span>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4 text-base md:text-lg text-slate-300 text-center mb-6 md:mb-10" data-id="element-249">
          <p className="text-xl md:text-2xl font-heading font-bold text-white" data-id="element-250">
            Imaginá esto por un segundo
          </p>
          <p data-id="element-251">
            Tu tripulación sabe exactamente qué hacer. Sin que tengas que
            explicarlo cada vez.
          </p>
          <p data-id="element-252">Las tareas fluyen. El barco funciona como un equipo.</p>
          <p data-id="element-253">Vos no corrés.</p>
          <p className="text-2xl md:text-3xl font-black text-gold-400 py-2 md:py-4" data-id="element-254">
            👉 Vos dirigís.
          </p>
          <p data-id="element-255">Y los clientes lo sienten.</p>
          <p data-id="element-256">Porque cuando hay orden…</p>

          <div className="flex flex-wrap justify-center gap-2 md:gap-3 py-2 md:py-4" data-id="element-257">
            <span className="bg-navy-900 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-navy-700 text-white font-medium text-sm md:text-base" data-id="element-258">
              👉 Hay profesionalismo.
            </span>
            <span className="bg-navy-900 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-navy-700 text-white font-medium text-sm md:text-base" data-id="element-259">
              👉 Hay consistencia.
            </span>
            <span className="bg-navy-900 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-navy-700 text-white font-medium text-sm md:text-base" data-id="element-260">
              👉 Hay mejor experiencia.
            </span>
            <span className="bg-navy-900 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-navy-700 text-white font-medium text-sm md:text-base" data-id="element-261">
              👉 Hay más valor.
            </span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-navy-900 to-navy-950 rounded-2xl p-5 md:p-8 border border-gold-500/30 text-center shadow-2xl" data-id="element-262">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-white mb-2 md:mb-3" data-id="element-263">
            ⚓ Existe un sistema para lograr esto
          </h2>
          <p className="text-base md:text-lg text-slate-300 mb-3 md:mb-4" data-id="element-264">
            Y fue creado específicamente para este problema.
          </p>
          <p className="text-sm md:text-base text-slate-400 mb-1" data-id="element-265">Se llama:</p>
          <h3 className="text-2xl md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-yellow-200 mb-5 md:mb-8" data-id="element-266">
            CHARTER COMMAND SYSTEM™
          </h3>

          <div className="text-left max-w-2xl mx-auto" data-id="element-267">
            <h4 className="text-base md:text-lg font-bold text-white mb-3 md:mb-4 flex items-center gap-2" data-id="element-268">
              <span data-id="element-269">🔧</span> ¿Qué es Charter Command System™?
            </h4>
            <p className="text-sm md:text-base text-slate-300 mb-3 md:mb-4" data-id="element-270">
              Es un sistema práctico, directo y aplicable desde el primer día.
            </p>
            <p className="text-sm md:text-base text-slate-300 mb-2 md:mb-3" data-id="element-271">
              Diseñado para que puedas:
            </p>
            <ul className="grid sm:grid-cols-2 gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-272">
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-273">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-274"></div>{' '}
                Estructurar tu operación
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-275">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-276"></div>{' '}
                Organizar tu tripulación
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-277">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-278"></div>{' '}
                Definir tareas claras
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-279">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-280"></div>{' '}
                Delegar sin perder control
              </li>
              <li className="flex items-center gap-2 text-slate-200 text-sm md:text-base" data-id="element-281">
                <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-282"></div>{' '}
                Eliminar el caos operativo
              </li>
            </ul>

            <div className="bg-navy-800/50 p-3 md:p-4 rounded-xl border-l-4 border-gold-500 mb-4 md:mb-6" data-id="element-283">
              <p className="text-sm md:text-base text-slate-300" data-id="element-284">
                No es teoría.
              </p>
              <p className="text-lg md:text-xl font-bold text-white mt-1 md:mt-2" data-id="element-285">
                👉 Es implementación real.
              </p>
            </div>

            <div className="text-center" data-id="element-286">
              <CTAButton data-id="element-287" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}